import React, { useState } from 'react';
import { MissingPhoneNumberModal } from '../../components';
import css from './ContactDetailsForm.css';

const VerifyPhoneNumberBlock = ({ phoneVerified, ...rest }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [refreshKey, setRefreshKey] = useState(new Date().getTime());

    return (
        <>
            {!phoneVerified && (
                <p className={css.verificationLink} onClick={() => setModalVisible(true)}>
                    Verifizieren
                </p>
            )}
            <MissingPhoneNumberModal
                id="ListingPage.missingPhoneNumberModal"
                initialState="enterPhoneNumber"
                key={refreshKey}
                isOpen={modalVisible}
                onClose={() => {
                    setModalVisible(false);
                    setRefreshKey(new Date().getTime());
                }}
                {...rest}
            />
        </>
    );
};

export default VerifyPhoneNumberBlock;
